import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73fcf99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable" }
const _hoisted_2 = { class: "editable__value" }


import {
  ref, PropType,
} from 'vue';
import { FieldContent, ActionParams } from './types';

const __default__ = {
  name: 'EditableCell',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: {
    type: String as PropType<string>,
    default: () => '',
  },
  value: {
    type: Object as PropType<FieldContent>,
    default: () => {},
  },
  actionParams: {
    type: Object as PropType<ActionParams>,
    default: () => {},
  },
},
  emits: ['action'],
  setup(__props, { emit }) {

const props = __props






const editable = ref(props.text);

const save = () => {
  const fieldName = props.value?.field_to_save || 'text';
  const customParam = { ...props.actionParams };
  customParam[fieldName] = editable.value;
  const data = {
    name: props.value?.action.name,
    type: 'event',
    customParam,
  };
  emit('action', data);
};


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(editable.value), 1),
    _createVNode(_component_q_popup_edit, {
      modelValue: editable.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((editable).value = $event)),
        save
      ]
    }, {
      default: _withCtx((scope) => [
        _createVNode(_component_q_input, {
          name: "editable",
          modelValue: scope.value,
          "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
          outlined: "",
          autofocus: "",
          dense: "",
          onKeypress: _withKeys(_withModifiers(scope.set, ["stop","prevent"]), ["enter"])
        }, {
          after: _withCtx(() => [
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              color: "negative",
              icon: "cancel",
              onClick: _withModifiers(scope.cancel, ["stop","prevent"])
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              color: "positive",
              icon: "check_circle",
              onClick: _withModifiers(scope.set, ["stop","prevent"])
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "onKeypress"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_icon, {
      name: "edit",
      color: "accent",
      size: "sm"
    })
  ]))
}
}

})